import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BackButton from 'components/BackButton';
import { StyledBlock, StyledTitle, StyledDescription } from 'pages/ParentalLock/StyledComponents';
import ActionsSection from 'pages/ParentalLock/ActionsSection';
import i18n from 'i18n';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';

export default class AutostartTVPage extends Component {
  componentDidUpdate(prevProps, prevState) {
    const { isAutostartTVEnabled, showToast } = this.props;
    const { isAutostartTVEnabled: prevPurchase } = prevProps;

    if (isAutostartTVEnabled !== prevPurchase) {
      showToast({
        options: { toastText: i18n.t('pc.saveChanges') },
      });
    }
  }

  onBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  onEnter = isAutostartTVEnabled => {
    const { history, setAutostartTV } = this.props;

    setAutostartTV(isAutostartTVEnabled);

    innerAnalyticsVolia.postEvent({
      eventGroup: 'profile',
      eventName: `autostart tv`,
      eventValue: isAutostartTVEnabled ? 'on' : 'off',
    });

    history.goBack();
  };

  render() {
    const { isAutostartTVEnabled } = this.props;

    return (
      <>
        <BackButton onEnter={this.onBack} />
        <div>
          <StyledBlock>
            <StyledTitle>{i18n.t('profile.autostarttv.title')}</StyledTitle>
          </StyledBlock>
          <StyledBlock>
            <StyledDescription>{i18n.t('profile.autostarttv.description')}</StyledDescription>
          </StyledBlock>
          <StyledBlock>
            <ActionsSection defaultSection>
              <ActionsSection.Button
                onEnter={() => this.onEnter(true)}
                label={i18n.t('profile.autostarttv.on')}
                type={'tick-button'}
                selected={isAutostartTVEnabled === true}
              />
              <ActionsSection.Button
                onEnter={() => this.onEnter(false)}
                label={i18n.t('profile.autostarttv.off')}
                type={'tick-button'}
                selected={isAutostartTVEnabled === false}
              />
            </ActionsSection>
          </StyledBlock>
        </div>
      </>
    );
  }
}

AutostartTVPage.propTypes = {
  history: PropTypes.object.isRequired,
  setAutostartTV: PropTypes.func.isRequired,
};
